import React, { useContext } from 'react';

import { ModalContext } from './Modal';

type Props = {
  title: React.ReactNode;
};

export default function ModalTitle({ title }: Props) {
  const { color } = useContext(ModalContext);

  return (
    <div
      className={`flex h-full w-full items-center justify-center text-lg font-bold leading-[140%] tracking-[-0.4px] ${
        color === 'white'
          ? 'text-apps-coreGrayBlack'
          : 'text-apps-coreGrayWhite'
      }`}
    >
      {title}
    </div>
  );
}
